import { lazy } from 'react'

const AuthRoute = [
  {
    path: '/login',
    component: lazy(() => import('../../login')),
    layout: '',
    meta: {
      authRoute: true
    }
  },
  {
    path: '/forgot-password',
    component: lazy(() => import('../../forgotPassword')),
    layout: 'BlankLayout',
    meta: {
      authRoute: true
    }
  },
  // {
  //   path: '/reset-password',
  //   component: lazy(() => import('../../views/authentication/ResetPassword')),
  //   layout: 'BlankLayout',
  //   meta: {
  //     authRoute: true
  //   }
  // }
]

export default AuthRoute
